/**
 * Centralized Color Constants for Tool Categories
 *
 * Usage:
 *   import { TOOL_COLORS, getCardBackground } from '../constants/colors';
 *
 *   // For buttons, icons, progress bars:
 *   bgcolor: TOOL_COLORS.EXCEL.primary
 *
 *   // For hover states:
 *   '&:hover': { bgcolor: TOOL_COLORS.EXCEL.hover }
 *
 *   // For light backgrounds (drag zones):
 *   bgcolor: TOOL_COLORS.EXCEL.light
 *
 *   // For card backgrounds with dark mode support:
 *   bgcolor: getCardBackground(theme)
 */

export const TOOL_COLORS = {
  PDF: {
    primary: '#DC143C',      // Crimson Red
    hover: '#B71C1C',        // Darker red for hover
    light: '#DC143C10',      // Light background tint (6% opacity)
  },
  EXCEL: {
    primary: '#228B22',      // Forest Green
    hover: '#1B6B1B',        // Darker green for hover
    light: '#228B2210',      // Light background tint (6% opacity)
  },
  LINK: {
    primary: '#3B82F6',      // Blue
    hover: '#2563EB',        // Darker blue for hover
    light: '#3B82F610',      // Light background tint (6% opacity)
  },
  OTHER: {
    primary: '#FF8C00',      // Dark Orange
    hover: '#E07800',        // Darker orange for hover
    light: '#FF8C0010',      // Light background tint (6% opacity)
  },
  AI: {
    primary: '#722F37',      // Merlot (deep wine/burgundy)
    hover: '#5A252C',        // Darker merlot for hover
    light: '#722F3710',      // Light background tint (6% opacity)
  },
  REPORTS: {
    primary: '#2FC4B2',      // Aqua Teal
    hover: '#26A89A',        // Darker aqua for hover
    light: '#2FC4B210',      // Light background tint (6% opacity)
  },
};

/**
 * Get card background color based on theme mode
 * @param {object} theme - MUI theme object
 * @returns {string} Background color hex value
 */
export const getCardBackground = (theme) =>
  theme.palette.mode === 'dark' ? '#2d2d2d' : '#f8f9fa';

/**
 * Get appropriate text color for a given background
 * @param {object} theme - MUI theme object
 * @returns {string} Text color
 */
export const getTextColor = (theme) =>
  theme.palette.mode === 'dark' ? '#ffffff' : '#333333';
